// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1rp4Y","label":"Radio_label__3hA2F","checkMark":"Radio_checkMark__3j3W7","disabled":"Radio_disabled__2YGdX"};